'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
require('offline-js');

exports.default = window.Offline;
//# sourceMappingURL=network.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/useragent/lib/network.js
// module id = 753
// module chunks = 1